import useSWR from 'swr'
import { RegistrantController } from '@/controllers'
import { config } from '@/config'
import { SeasonOrganization } from '@/interfaces/seasonOrganization'
import { Season } from '@/interfaces/season'
import { result } from '@/interfaces/task'

export const SEASON_ORGANIZATION_KEY = config.api.endpoints.registrant.seasonOrganization

export const useSeasonOrganization = (
  hasParticipants?: boolean,
): {
  season: Season | null
  seasonOrganization: SeasonOrganization | null
  error: string | null
  isLoading: boolean
  revalidate: () => Promise<result<SeasonOrganization>>
} => {
  const {
    data,
    error: uncaughtError,
    isLoading,
    mutate,
  } = useSWR(SEASON_ORGANIZATION_KEY, RegistrantController.currentSeasonOrganization)

  const seasonOrganization = data?.result?.[1] || null
  const season = seasonOrganization?.season || null
  const error = data?.result?.[0] || uncaughtError

  const revalidate = async () => {
    const response = await mutate()

    if (!response) {
      throw new Error('Failed to revalidate seasonOrganization')
    }

    return response.result
  }

  return {
    season,
    seasonOrganization,
    error,
    isLoading,
    revalidate,
  }
}
